<template>
  <BasicLayout :left='left' :middle='middle' :right='right'>
    <template v-slot:left_view>
      <NeList ref='neList' :neArr='netype' :select='neClick'></NeList>
    </template>
    <template v-slot:right_view>
      <SnssaiTableMenu @methodEnum='methodEnum'></SnssaiTableMenu>
      <SnssaiTable ref="snssaiTable"></SnssaiTable>
    </template>
  </BasicLayout>
</template>

<script>
import SnssaiTable from '../../../../components/subscriberconfig/udmSubscriber/snssai/SnssaiTable';
import SnssaiTableMenu from '../../../../components/subscriberconfig/udmSubscriber/snssai/SnssaiTableMenu';
import BasicLayout from '../../../../layouts/BasicLayout';
import NeList from '../../../../components/common/NeList';

export default {
  name: 'SnssaiMainPage',
  components: {
    NeList,
    SnssaiTable,
    SnssaiTableMenu,
    BasicLayout,
  },
  data() {
    return {
      left: {
        show: true,
        name: this.$t("Profile.nelist"),
      },
      middle: {
        show: false,
        name: ''
      },
      right: {
        show: true,
        crumb: this.$t("Snssai.crumb"),
      },
      netype: [36],
    };
  },
  methods: {
    methodEnum(opcode) {
      switch (opcode) {
        case 'add':
          this.$refs.snssaiTable.openAddProfilePage();
          break;
        case 'mod':
          this.$refs.snssaiTable.openModProfilePage();
          break;
        case 'del':
          this.$refs.snssaiTable.delProfiles();
          break;
        case 'qry':
          this.$refs.snssaiTable.qryProfiles(true);
          break;
        default:
      }
    },
    neClick() {
      this.$refs.snssaiTable.getGridData(this.$refs.neList.getNe());
    }
  }
};
</script>

<style scoped>

</style>
